import { RefObject, createContext } from 'react';
import type { Draw, GridLayer, Handler, Map, TileLayer } from 'leaflet';
import type { MapTiles } from '../../../../constants/mapConstants';
import type { useRegionBinder } from './effects';

type MapContextValue = {
  line: Draw.Polyline;
  map: Map;
  carrier: HTMLElement;
  regionBinder: ReturnType<typeof useRegionBinder>;
  poly: Handler;
  toggleTiles: () => void;
  setTiles: (tiles: MapTiles) => void;
  ignTiles: RefObject<TileLayer>;
  googleMutantTiles: RefObject<GridLayer>;
  emptyTiles: RefObject<TileLayer>;
};

const Context = createContext<MapContextValue>({} as MapContextValue);

export default Context;
